import { ENDPOINT } from '@old/data/core/endpoints';
import { useGlobalStore } from '@old/global-store/use-store';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { LastBalanceResponse } from './mov-stock-last-balance.types';

// deprecated service ref.: getLastBalanceReportStockService_DEPRECATED
export async function stockLastBalanceService() {
  const { organizationId } = useGlobalStore.getState();
  const query = transformIntoQueryParamString(organizationId);

  const { response, data } = await BACKEND.get<LastBalanceResponse>(ENDPOINT.REPORT_STOCK_LASTBALANCE, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
